// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2MyQ3","rootSuccess":"CompleteLink_rootSuccess__2qjc3","rootFailure":"CompleteLink_rootFailure__3oy_m","isDisabled":"CompleteLink_isDisabled__1ZOV8"};